import React, { useEffect, useState } from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import BudgetImpacts from '../../collection-templates/budget-impacts';
import { isEmpty } from 'lodash';

const BudgetImpactFullWidget = (props) => {
  const [collectionData, setCollectionData] = useState({});
  const queryClient = new QueryClient;

  useEffect(() => {
    const getCollectionData = async () => {
      if (isEmpty(collectionData)) {
        try {
          const response = await fetch('https://www.ndtvprofit.com/api/v1/collections/budget-impact').then(res => res.json());
          setCollectionData(response);
        } catch (e) {
          console.log('Error in api');
        }
      }
    }

    getCollectionData();
    const body = document.getElementsByTagName('body')[0];
    body.style.backgroundColor = "#0B0B0B";
  }, []);
  return (
    <QueryClientProvider client={queryClient}>
      {!isEmpty(collectionData) && (
        <BudgetImpacts
          collection={collectionData}
          widget={true}
          target="_parent"
          {...props}/>
      )}
    </QueryClientProvider>
  );
};

export { BudgetImpactFullWidget };
